let odd = {
    pinned: ["GPName"],
    width: {
      GPName: 240,
    },
    immutable: {
      GPName: false,
    },
    mapping: {
      GPName: {
        header: "GP Name",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "GPName",
      },
      column_0A: {
        header: "0A",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_0A",
      },
      column_0B: {
        header: "0B",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_0B",
      },
      column_0C: {
        header: "0C",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_0C",
      },
      column_0D: {
        header: "0D",
        rules: null,
        dataType: "date",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_0D",
      },
      column_0E: {
        header: "0E",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_0E",
      },
      column_1A: {
        header: "1A",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_1A",
      },
      column_1B: {
        header: "1B",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_1B",
      },
      column_1C: {
        header: "1C",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_1C",
      },
      column_1D: {
        header: "1D",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_1D",
      },
      column_1E: {
        header: "1E",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_1E",
      },
      column_1F: {
        header: "1F",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_1F",
      },
      column_1G: {
        header: "1G",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_1G",
      },
      column_1H: {
        header: "1H",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_1H",
      },
      column_2A: {
        header: "2A",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_2A",
      },
      column_2B: {
        header: "2B",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_2B",
      },
      column_2C: {
        header: "2C",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_2C",
      },
      column_2D: {
        header: "2D",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_2D",
      },
      column_2E: {
        header: "2E",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_2E",
      },
      column_2F: {
        header: "2F",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_2F",
      },
      column_3A: {
        header: "3A",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_3A",
      },
      column_3B: {
        header: "3B",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_3B",
      },
      column_3C: {
        header: "3C",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_3C",
      },
      column_4A: {
        header: "4A",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_4A",
      },
      column_4B: {
        header: "4B",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_4B",
      },
      column_4C: {
        header: "4C",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_4C",
      },
      column_4D: {
        header: "4D",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_4D",
      },
      column_4E: {
        header: "4E",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_4E",
      },
      column_4F: {
        header: "4F",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_4F",
      },
      column_4G: {
        header: "4G",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_4G",
      },
      column_4H: {
        header: "4H",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_4H",
      },
      column_4I: {
        header: "4I",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_4I",
      },
      column_4J: {
        header: "4J",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_4J",
      },
      column_4K: {
        header: "4K",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_4K",
      },
      column_4L: {
        header: "4L",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_4L",
      },
      column_4M: {
        header: "4M",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_4M",
      },
      column_5A: {
        header: "5A",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_5A",
      },
      column_5B: {
        header: "5B",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_5B",
      },
      column_5C: {
        header: "5C",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_5C",
      },
      column_6Ai: {
        header: "6Ai",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_6Ai",
      },
      column_6Aii: {
        header: "6Aii",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_6Aii",
      },
      column_6Aiii: {
        header: "6Aiii",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_6Aiii",
      },
      column_6Aiv: {
        header: "6Aiv",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_6Aiv",
      },
      column_6Av: {
        header: "6Av",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_6Av",
      },
      column_6Avi: {
        header: "6Avi",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_6Avi",
      },
      column_6B: {
        header: "6B",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_6B",
      },
      column_7A: {
        header: "7A",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_7A",
      },
      column_7B: {
        header: "7B",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_7B",
      },
      column_7C: {
        header: "7C",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_7C",
      },
      column_7D: {
        header: "7D",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_7D",
      },
      column_7E: {
        header: "7E",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_7E",
      },
      column_7F: {
        header: "7F",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_7F",
      },
      column_7G: {
        header: "7G",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_7G",
      },
      column_7H: {
        header: "7H",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_7H",
      },
      column_7I: {
        header: "7I",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_7I",
      },
      column_7J: {
        header: "7J",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_7J",
      },
      column_8A: {
        header: "8A",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_8A",
      },
      column_8B: {
        header: "8B",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_8B",
      },
      column_8C: {
        header: "8C",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_8C",
      },
      column_8D: {
        header: "8D",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_8D",
      },
      column_8E: {
        header: "8E",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_8E",
      },
      column_8F: {
        header: "8F",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_8F",
      },
      column_8G: {
        header: "8G",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_8G",
      },
      column_9A: {
        header: "9A",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_9A",
      },
      column_9B: {
        header: "9B",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_9B",
      },
      column_9C: {
        header: "9C",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_9C",
      },
      column_9D: {
        header: "9D",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_9D",
      },
      column_9E: {
        header: "9E",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_9E",
      },
      column_9F: {
        header: "9F",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_9F",
      },
      column_10A: {
        header: "10A",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_10A",
      },
      column_10B: {
        header: "10B",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_10B",
      },
      column_10C: {
        header: "10C",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_10C",
      },
      column_10D: {
        header: "10D",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_10D",
      },
      column_10E: {
        header: "10E",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_10E",
      },
      column_10F: {
        header: "10F",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_10F",
      },
      column_10G: {
        header: "10G",
        rules: null,
        dataType: "text",
        meta: null,
        palceholder: null,
        validations: null,
        col: "column_10G",
      },
    },
  };
  export { odd };